/** @format */

import { configureStore } from "@reduxjs/toolkit";
import stateSlice from "./stateSlice";
import authReducer from "./auth";
import category from "./category";
import service from "./service";
import clientSlice from "./clients";
import dashboard from "./dashboard";
import orders from "./orderHistory";
import AirportsSlice from "./airports";
import driversSlice from "./drivers";
import ExpensesSlice from "./expenses";
import banners from "./banners";
import managers from "./managers";
import categoriesStatistics from "./categoriesStatistics";
export const store = configureStore({
  reducer: {
    toggleState: stateSlice,
    auth: authReducer,
    airports: AirportsSlice,
    drivers: driversSlice,
    expenses: ExpensesSlice,
    categoriesStatistics : categoriesStatistics ,
    dashboard,
    category,
    service,
    clientSlice,
    orders,
    banners,
    managers,
  },
});
